function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 48 48"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M46 12a2 2 0 012 2v.8a2 2 0 01-2 2H2a2 2 0 01-2-2V14c0-1.1.9-2 2-2h44zm0 9.6a2 2 0 012 2v.8a2 2 0 01-2 2H2a2 2 0 01-2-2v-.8c0-1.1.9-2 2-2h44zm0 9.6a2 2 0 012 2v.8a2 2 0 01-2 2H2a2 2 0 01-2-2v-.8c0-1.1.9-2 2-2h44z"
})));